module.exports = __webpack_public_path__ + "static/img/image_recruit_10.c5066a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/join/image_recruit_10.png
// module id = OoPt
// module chunks = 10